import { GnCarousel } from "../libraries/slick";

const SELECTORS = {
  component: ".js-main-slider",
};

const sliderInstance = [...document.querySelectorAll(SELECTORS.component)];

if (sliderInstance) {
  const OPTIONS = {
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableHeight: true,
  };

  sliderInstance.forEach((slider) => {
    const parent = slider.parentElement;
    const slickInstance = new GnCarousel(slider, OPTIONS, parent);

    slickInstance.initCarousel();
  });
}
let $texts = document.querySelectorAll('.main-slider__body p:nth-child(2)');

$texts.forEach($text => {
  console.log($text);
  $text.textContent = $text.textContent + '...';
});
